import {ICouponPayload} from "../interfaces/coupons";
export class Coupon implements ICouponPayload {
  public title : string;
  public id : number;
  public expired : boolean;
  constructor(payload : ICouponPayload){
    this.title = payload.title;
    this.id = payload.id;
    this.expired = !!payload.expired;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/coupon.ts